module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/sp-cover-4-f301341a74fc33e6bb9c786099cb7fe4.webp";